import withPropsOnChange from "recompose/withPropsOnChange"
import { ERROR, LOADED, LOADING } from "@/helpers/stateMachine"

export default withPropsOnChange(["loading"], ({ error, loading }) => ({
  status: loading ? LOADING : error ? ERROR : LOADED,
}))
